import './Logs.scss';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { InstanceStatus } from './LogsDatas';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';

export enum LogTypes {
    LOGS = 'logs',
    PREVIOUS = 'previous',
    REASON = 'reason'
}

export const Logs = ({instanceStatus}: {
    instanceStatus: InstanceStatus
}) => {

    const {t: translate} = useTranslation();
    const DROPDOWN_TYPES: {label: string, value: string}[] = [
        {label: translate('flow_logs.types.logs'), value: LogTypes.LOGS},
        {label: translate('flow_logs.types.previous'), value: LogTypes.PREVIOUS},
        {label: translate('flow_logs.types.reason'), value: LogTypes.REASON}
    ];
    const [type, setType] = useState<string>(DROPDOWN_TYPES[0].value);

    const formatLogs = (logs: string) => {
        const logRows: JSX.Element[] = [];
        const lines = logs.replaceAll('\\t', '\\tat')
            .replaceAll('\tat', '\\tat')
            .replaceAll('\n', '\\n')
            .split('\\n');

        lines.forEach((line, index) => {
            let className = '';
            if (line.startsWith('\\tat')) {
                className = 'tab';
                line = line.substring(4, line.length);
            } else if (line.startsWith('{')) {
                className = 'marginLine';
            }
            logRows.push(<div key={index} className={className}>{line}</div>)
        })
        return logRows;
    }

    const getLogsByType = () => {
        switch (type) {
            case LogTypes.LOGS:
                return instanceStatus.data.logs;
            case LogTypes.PREVIOUS:
                return instanceStatus.data.previous;
            case LogTypes.REASON:
                return instanceStatus.data.reason;
            default:
                return instanceStatus.data.logs;
        }
    }

    const FormatByType = () => {
        const logsToDisplay = getLogsByType();

        if (logsToDisplay !== "") {
            return <>{logsToDisplay ? formatLogs(logsToDisplay) : null}</>;
        } else {
            return <p className={'empty'}>{translate('flow_logs.logs.not_available')}</p>;
        }
    }

    const copyToClipboard = () => {
        const logsToClipboard = getLogsByType();
        navigator.clipboard.writeText(logsToClipboard !== "" ? logsToClipboard : translate('flow_logs.logs.not_available'));
    }

    return <div className={'logsSection dont-overflow scroll'}>
        <div className={'header'}>
            <h3>{translate('flow_logs.logs.title')}</h3>
            <Button
                onClick={() => {
                    copyToClipboard()
                }}
                label={translate('flow_logs.logs.copy')}
                icon="pi pi-copy"
                className="p-button-text"
            />
            <Dropdown
                value={type} className="flex align-items-center w-10rem"
                options={DROPDOWN_TYPES} optionLabel="label"
                onChange={(e) => setType(e.value)}
            />
        </div>
        <div className={'logs'} >
            <FormatByType />
        </div>
    </div>
}
